<template>
  <footer class="footer-menu">
    <wrapper class="desktop">
      <div class="row-menu">
        <div class="column-logo">
          <div class="inner">
            <link-to to="/" class="logo"><img src="/logo.png" alt="Russ Outdoor"></link-to>
          </div>
        </div>

        <div class="column-menu">
          <ul class="main-item">
            <li class="item" v-for="(value,index) in menu" :key="index">
              <a :href="value.link" class="main">{{value.name}}</a>
              <ul v-if="value.items">
                <li v-for="(v,i) in value.items" :key="i"><nuxt-link :to="v.link"  class="i">{{v.name}}</nuxt-link></li>
              </ul>
            </li>
          </ul>
        <div>
          <social-links buttonClass="round--white"/>
        </div>
        </div>
      </div>
      <div class="row-copyright" v-if="copyright">
        <span v-html="copyright"></span>
      </div>
      <div class="text-center">
        <a class="a-white solid oferta" href="/upload/docs/pdf/privacy_policy_www.pdf"  style="margin-right: 10px;" target="_blank">Политика конфиденциальности</a>
        <a class="a-white solid oferta" href="/illegal_actions_message/"  style="margin-right: 10px;" target="_blank">Сообщить о противоправных действиях</a>
        <br>
        <a class="a-white solid oferta"  v-if="isDocsPage" href="https://files.russoutdoor.ru/cp/"  style="margin-right: 10px;" target="_blank">Коммерческая политика</a>
      </div>
    </wrapper>
    <wrapper class="mobile">
      <div class="flex">
          <div class="copyright" v-if="copyright" v-html="copyright"></div>
          <social-links buttonClass="round--white"/>
      </div>
      <div class="text-center oferta"> <a class="a-white" href="/oferta" target="_blank">Политика конфиденциальности</a></div>
    </wrapper>
  </footer>
</template>

<script>
  import SocialLinks from '~/components/shared/SocialLinks'

  export default {

    data() {
      return {
          menuFooter: {

          }
      }
    },
    computed: {
      menu() {
        return this.$store.state.menu.menuItems.btm.items;
      },
      load() {
        return this.$store.getters['main/copyright']['loaded']
      },
      copyright() {
        return this.load ? this.$store.getters['main/copyright']['item'][0].copyright : []
      },
      isDocsPage() {
        return ($nuxt.$route.path.indexOf('company/docs') !== -1);
      }
    },
    mounted() {
      this.$store.dispatch('menu/loadMenu', 'btm');
      if (!this.load) this.$store.dispatch('main/fetchCopyright');
    },
    components: {
      SocialLinks,
    }
  }
</script>

<style lang="scss">
  .footer-menu {
    background: $color-black-1;
    color: $color-white;
    padding: 50px 0;
    @media (max-width: $media_md) {
        padding: 15px 0px;
    }

    .flex {
      display: flex;display: -ms-flexbox;
      justify-content: space-between; -ms-flex-pack: justify;
      align-items: center;
      .social-icons {
         margin-right: 10px;
      }
    }

  }

  .row-menu {
    padding: 0 0 15px;
    display: flex;display: -ms-flexbox;
    flex-flow: row nowrap;
    @media(max-width: 480px) {
      flex-flow: column nowrap;
    }
    .column-logo {
      flex: 0 0 150px;
      @media(max-width: 480px) {
        flex: 1 0 auto;
      }
      & > .inner {
        padding: 0 25px 35px 0;
      }
      img {
        height: 35px;
      }
    }
    .column-menu {
      display: flex;display: -ms-flexbox;
      width: 100%;
      ul {
        &.main-item {
          display: flex;display: -ms-flexbox;
          flex-wrap: wrap;
          flex: auto;
        }
         li {
           &.item {
              width: 25%;
             ul {
               padding-top: 8px;
               li {
                 padding: 5px 0px;
               }
             }
           }
           a {
             &.main {
               color: $color-white;
               border-bottom: 1px solid $color-white;
               line-height: 12px;
             }
             display: inline-block;
             padding: 5px 0;
             color: rgba($color-white,0.5);
             text-transform: uppercase;
             text-decoration: none;
             &.path-exist,
             &.path-exact {
               border-bottom: 2px solid $color-white;
             }
             &:hover {
               color: $color-white;
               border-bottom-color: transparent;
             }
           }
         }
      }

      .btn {
        margin-right: 0;
        @media(max-width: 800px) {
          align-self: flex-end;
          margin-top: 15px;
        }
        @media(max-width: 600px) {
          flex: 1 0 auto;
        }
      }
    }

  }
  @media (max-width: $media_sm) {
    .oferta {
      font-size: 12px;
      margin: 25px 0px 10px;
    }
  }
  .row-copyright {
    padding: 15px 0 5px;
    display: flex;display: -ms-flexbox;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
    @media (max-width: 800px) {
      width: 100%;
      padding: 0;
    }
    .btn-social {
      margin-left: 20px;
    }


  }

  // Disable hover for touch devices
  body.touch {
    .row-menu .column-menu ul li a:hover {
      color: $color-white !important;
      border-bottom-color: $color-white !important;
    }
  }
</style>



// WEBPACK FOOTER //
// components/footer/FooterMenu.vue